import React from "react";
import { Download, LocateFixed } from "lucide-react";
import Tooltip from "../../ui/Tooltip";

const TOOLBAR_BUTTON_CLASS =
  "inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-200 transition-colors hover:bg-white/10 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-500/80 disabled:cursor-not-allowed disabled:opacity-45 disabled:hover:bg-transparent disabled:hover:text-gray-200";

function ToolbarButton({ label, disabled, onClick, children }) {
  return (
    <Tooltip content={label} side="bottom">
      <button
        type="button"
        className={TOOLBAR_BUTTON_CLASS}
        aria-label={label}
        disabled={disabled}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onClick?.();
        }}
      >
        {children}
      </button>
    </Tooltip>
  );
}

const SceneGraphViewportToolbar = React.memo(function SceneGraphViewportToolbar({
  exporting,
  onRecenter,
  onDownloadSvg,
}) {
  return (
    <div
      className="absolute left-3 z-20 inline-flex items-center gap-1 rounded-lg p-1 text-xs select-none"
      style={{
        top: "0.75rem",
        backgroundColor: "rgba(18, 18, 20, 0.88)",
        backdropFilter: "blur(6px)",
      }}
      onPointerDown={(event) => event.stopPropagation()}
      onContextMenu={(event) => {
        event.preventDefault();
        event.stopPropagation();
      }}
    >
      <ToolbarButton label="Recenter graph view" onClick={onRecenter}>
        <LocateFixed className="h-4 w-4" aria-hidden />
      </ToolbarButton>
      <ToolbarButton
        label={exporting ? "Exporting SVG" : "Download graph as SVG"}
        disabled={exporting}
        onClick={onDownloadSvg}
      >
        <Download className="h-4 w-4" aria-hidden />
      </ToolbarButton>
    </div>
  );
});

export default SceneGraphViewportToolbar;
